import React from "react";

const IntelliJIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      x="0"
      y="0"
      enableBackground="new 0 0 70 70"
      version="1.1"
      viewBox="0 0 70 70"
      xmlSpace="preserve"
    >
      <linearGradient
        id="SVGID_1_"
        x1="0.79"
        x2="33.317"
        y1="40.089"
        y2="40.089"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.258" stopColor="#F97A12"></stop>
        <stop offset="0.459" stopColor="#B07B58"></stop>
        <stop offset="0.724" stopColor="#577BAE"></stop>
        <stop offset="0.91" stopColor="#1E7CE5"></stop>
        <stop offset="1" stopColor="#087CFA"></stop>
      </linearGradient>
      <path
        fill="url(#SVGID_1_)"
        d="M17.7 54.6L0.8 41.2 9.2 25.6 33.3 35z"
      ></path>
      <linearGradient
        id="SVGID_2_"
        x1="25.767"
        x2="79.424"
        y1="24.88"
        y2="54.57"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#F97A12"></stop>
        <stop offset="0.072" stopColor="#CB7A3E"></stop>
        <stop offset="0.154" stopColor="#9E7B6A"></stop>
        <stop offset="0.242" stopColor="#757B91"></stop>
        <stop offset="0.334" stopColor="#537BB1"></stop>
        <stop offset="0.432" stopColor="#387CCC"></stop>
        <stop offset="0.538" stopColor="#237CE0"></stop>
        <stop offset="0.655" stopColor="#147CEF"></stop>
        <stop offset="0.792" stopColor="#0B7CF7"></stop>
        <stop offset="1" stopColor="#087CFA"></stop>
      </linearGradient>
      <path
        fill="url(#SVGID_2_)"
        d="M70 18.7L68.7 59.2 41.8 70 25.6 59.6 49.3 35 38.9 12.3 48.2 1.1z"
      ></path>
      <linearGradient
        id="SVGID_3_"
        x1="63.228"
        x2="48.29"
        y1="42.915"
        y2="-1.719"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#FE315D"></stop>
        <stop offset="0.078" stopColor="#CB417E"></stop>
        <stop offset="0.16" stopColor="#9E4E9B"></stop>
        <stop offset="0.247" stopColor="#755BB4"></stop>
        <stop offset="0.339" stopColor="#5365CA"></stop>
        <stop offset="0.436" stopColor="#386DDB"></stop>
        <stop offset="0.541" stopColor="#2374E9"></stop>
        <stop offset="0.658" stopColor="#1478F3"></stop>
        <stop offset="0.794" stopColor="#0B7BF8"></stop>
        <stop offset="1" stopColor="#087CFA"></stop>
      </linearGradient>
      <path
        fill="url(#SVGID_3_)"
        d="M70 18.7L48.7 43.9 38.9 12.3 48.2 1.1z"
      ></path>
      <linearGradient
        id="SVGID_4_"
        x1="10.72"
        x2="55.524"
        y1="16.473"
        y2="90.58"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#FE315D"></stop>
        <stop offset="0.04" stopColor="#F63462"></stop>
        <stop offset="0.104" stopColor="#DF3A71"></stop>
        <stop offset="0.167" stopColor="#C24383"></stop>
        <stop offset="0.291" stopColor="#AD4A91"></stop>
        <stop offset="0.55" stopColor="#755BB4"></stop>
        <stop offset="0.917" stopColor="#1D76ED"></stop>
        <stop offset="1" stopColor="#087CFA"></stop>
      </linearGradient>
      <path
        fill="url(#SVGID_4_)"
        d="M33.7 58.1L5.6 68.3 10.1 52.5 16 33.1 0 27.7 10.1 0 32.1 2.7 53.7 27.4z"
      ></path>
      <g>
        <path d="M13.7 13.5H56.900000000000006V56.7H13.7z"></path>
        <path fill="#FFF" d="M17.7 48.6H33.9V51.300000000000004H17.7z"></path>
        <path
          fill="#FFF"
          d="M29.4 22.4L29.4 19.1 20.4 19.1 20.4 22.4 23 22.4 23 33.7 20.4 33.7 20.4 37 29.4 37 29.4 33.7 26.9 33.7 26.9 22.4z"
        ></path>
        <path
          fill="#FFF"
          d="M38 37.3c-1.4 0-2.6-.3-3.5-.8-.9-.5-1.7-1.2-2.3-1.9l2.5-2.8c.5.6 1 1 1.5 1.3.5.3 1.1.5 1.7.5.7 0 1.3-.2 1.8-.7.4-.5.6-1.2.6-2.3V19.1h4v11.7c0 1.1-.1 2-.4 2.8-.3.8-.7 1.4-1.3 2-.5.5-1.2 1-2 1.2-.8.3-1.6.5-2.6.5"
        ></path>
      </g>
    </svg>
  );
};

export default IntelliJIcon;
